"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORGANIZATION_TYPE_LABELS = void 0;
exports.ORGANIZATION_TYPE_LABELS = {
    PARDOT: 'Pardot',
    SALESFORCE: 'Salesforce',
    SONAR: 'Arovy'
};
//# sourceMappingURL=ORGANIZATION_TYPE_LABELS.js.map